import {mainLang} from './skills';


export const mainLanguages = [
    {
        id: mainLang.py.id,
        src: "images/experience/python-logo.svg",
        alt: "programming language logo for Python"
    },
    {
        id: "DevOps",
        src: "images/experience/devops.avif",
        alt: "DevOps, Continuous Integration and Continuous Delivery (CI/CD) logo. A blue background with a white infinity symbol in the middle of the image."
    },
    {
        id: "Amazon Web Services (AWS)",
        src: "images/experience/aws-logo.png",
        alt: "Amazon Web Services (AWS) logo"
    },
    {
        id: mainLang.js.id,
        src: "images/experience/js-logo.svg",
        alt: "programming language logo for JavaScript"
    },
];